import { combineReducers } from 'redux';

import curriculum from './curriculum';
import disciplines from './disciplines';
import data from './data';
import isLoading from './isLoading';
import current from './current';
import currentStatus from './currentStatus';



const complexTopicsDisciplines = combineReducers({ curriculum, disciplines, data, current, currentStatus, isLoading });

export default complexTopicsDisciplines